import React from "react";

// Renders article HTML but extracts <iframe> video embeds and renders them as
// real React iframes (JSX). Raw iframe strings injected via dangerouslySetInnerHTML
// get neutralized/sanitized in some environments (shown as an empty black box),
// while React-created iframes render reliably.
const IFRAME_RE_G = /<iframe\b[^>]*>\s*<\/iframe>/gi;

const getSrc = (tag) => {
  const m = tag.match(/\ssrc\s*=\s*"([^"]*)"/i) || tag.match(/\ssrc\s*=\s*'([^']*)'/i);
  return m ? m[1] : "";
};

export const ArticleBody = ({ html, testId = "article-body", className = "prose-sl mt-8" }) => {
  if (!html) return null;

  // Drop the responsive aspect-ratio wrapper so we re-create it in React around the iframe.
  const normalized = html.replace(
    /<div[^>]*padding-bottom:\s*56\.25%[^>]*>\s*(<iframe\b[^>]*>\s*<\/iframe>)\s*<\/div>/gi,
    "$1"
  );

  const parts = [];
  let lastIndex = 0;
  let m;
  const re = new RegExp(IFRAME_RE_G);
  while ((m = re.exec(normalized)) !== null) {
    if (m.index > lastIndex) parts.push({ type: "html", content: normalized.slice(lastIndex, m.index) });
    parts.push({ type: "iframe", src: getSrc(m[0]) });
    lastIndex = re.lastIndex;
  }
  if (lastIndex < normalized.length) parts.push({ type: "html", content: normalized.slice(lastIndex) });

  return (
    <div data-testid={testId} className={className}>
      {parts.map((p, i) =>
        p.type === "iframe" && p.src ? (
          <div key={i} data-testid={`embedded-video-${i}`} style={{ position: "relative", width: "100%", paddingBottom: "56.25%", margin: "1.5rem 0" }}>
            <iframe
              src={p.src}
              title="video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0, borderRadius: "12px" }}
            />
          </div>
        ) : (
          <div key={i} dangerouslySetInnerHTML={{ __html: p.content }} />
        )
      )}
    </div>
  );
};

export default ArticleBody;
